<!-- 医生线下出诊时间 -->
<template>
  <div class="doct_schedule">
    <div class="desc" v-if="showHead">
      <span>线下门诊时间</span>
      <div class="descAct" @click="emit('helpEditDoc')">
        <span class="helpIn">帮助医生修改</span>
        <auth-img :src="iconSrc" class="right" alt="" />
      </div>
      <!-- <div v-else>
        <span class="fold" @click="handleFold">{{ isFold ? '展开' : '收起' }}</span>
      </div> -->
    </div>
    <div class="hospital_list">
      <a-select
        :value="activeItem.hospitalId"
        :bordered="false"
        style="width: 100%"
        @change="handleChange"
      >
        <a-select-option
          v-for="item in hospitalList"
          :key="item.hospitalId"
          :value="item.hospitalId"
        >
          {{ item.hospitalName }}
        </a-select-option>
      </a-select>
    </div>
    <ul v-if="activeItem.sourceType === 0">
      <li class="content time">
        <div class="title top_left"></div>
        <div>上午</div>
        <div class="bottom_left">下午</div>
      </li>
      <li class="content" v-for="(item, index) in activeItem.scheduleList" :key="index">
        <div class="title" :class="{ top_right: index == 6 }">{{ headerTxt[index + 1] }}</div>
        <div class="schedule">
          <template v-if="item[0]"><CheckOutlined class="have_schedule" /></template>
        </div>
        <div class="schedule" :class="{ bottom_right: index == 6 }">
          <template v-if="item[1]"><CheckOutlined class="have_schedule" /></template>
        </div>
      </li>
    </ul>
    <div class="schedule_table" v-else :style="{ height: isFold ? '0' : '146px' }">
      <div
        v-for="(schedule, scheduleIndex) in hisSchedule"
        :key="scheduleIndex"
        class="hospital_schedule"
      >
        <div class="content">
          <div class="title box"></div>
          <div class="box grey">上午</div>
          <div class="box grey">下午</div>
        </div>
        <div class="content" v-for="(item, index) in schedule" :key="index">
          <div :class="`title box`">
            <div class="date">{{ formatDate(item?.shiftScheduleDate) }}</div>
            <div class="week">{{ item?.week }}</div>
          </div>
          <div
            class="box"
            v-for="(numberItem, numberIndex) in item.doctorScheduleSurplusCountVOS"
            :key="numberIndex"
          >
            <div v-if="!numberItem"></div>
            <div v-else-if="numberItem.isOpen === '1'" class="flex-col">
              <div>余号</div>
              <div :class="numberItem?.surplusCount === '0' ? 'grey' : null">
                {{ numberItem?.surplusCount }}
              </div>
            </div>
            <div v-else class="grey">停诊</div>
          </div>
        </div>
      </div>
    </div>
    <div class="updateTime" v-if="operationLog.formatOperationString">
      <!-- 2024-06-11 16:09 由 健管-王嘉欣 修改 -->
      {{ operationLog.formatOperationString }}
    </div>
  </div>
</template>
<script setup>
import { CheckOutlined } from '@ant-design/icons-vue'
import { ref, defineProps, defineEmits, watch, onMounted, onUnmounted, computed } from 'vue'
import { getDoctorScheduling, getOutPatientList } from '@/api/chat'
import { useStore } from 'vuex'
import { getDrOutpatientInfoLog } from '@/api/workPlace/appoint'
import { REFRESH_SCHEDULE } from '@/views/WorkPlace/handleEventBuss'
const props = defineProps({
  showHead: {
    type: Boolean,
    required: false,
    default: true
  },
  bindUcDoctorId: {
    type: String,
    required: false,
    default: ''
  }
})
const store = useStore()
const hisSchedule = ref([]) // 医院排班
const isFold = ref(false) // 线上出诊时间是否展开
const doctorInfo = computed(() => store.state.workOrder.workOrderGroupInfo?.doctorInfo || {})
const ucDoctorId = computed(() => props.bindUcDoctorId || doctorInfo.value.ucUserId)

const hospitalList = ref([]) // 医生所有职业点
const activeItem = ref({}) // 当前选中的职业点

// 获取his排班
const getHospitalSetting = async hospitalId => {
  try {
    const params = {
      ucDoctorId: ucDoctorId.value,
      hospitalId
    }
    const data = (await getDoctorScheduling(params)) || []
    hisSchedule.value = formatDateSchedule(data)
  } catch (error) {
    hisSchedule.value = []
  }
}

// 日期展示格式化
const formatDate = date => {
  if (!date) return
  const cut = date.substring(5).split('-')
  return cut?.join('.')
}

// 控制出诊时间展开收起
const handleFold = () => {
  isFold.value = !isFold.value
}

const formatDateSchedule = data => {
  const newList = data?.map(item => {
    const { doctorScheduleSurplusCountVOS } = item
    return {
      ...item,
      doctorScheduleSurplusCountVOS: doctorScheduleSurplusCountVOS
        ? doctorScheduleSurplusCountVOS
        : [null, null]
    }
  })
  return [newList?.slice(0, 7), newList?.slice(7)]
}
// 获取医生所有职业点
const getHospitalList = () => {
  ucDoctorId.value &&
    getOutPatientList({
      ucDoctorId: ucDoctorId.value
    })
      .then(result => {
        if (result.length > 0 && Array.isArray(result)) {
          const data = result
            .filter(item => {
              // 只展示第一职业点和有排班的医院 + his排班
              return item.sourceType || item.firstHospitalFlag || !item.registerFlag
            })
            .map(item => {
              const { sourceType } = item || {}
              const consultationTime = JSON.parse(item.consultationTime)
              let list = []
              // 平台排班需要处理一下数据结构，his排班调用接口获取
              if (sourceType == 0) {
                if (Object.keys(consultationTime).length === 0) {
                  list = new Array(7).fill([0, 0])
                } else {
                  const _list = []
                  Object.keys(consultationTime).forEach(key => {
                    _list.push(consultationTime[key])
                  })
                  list = _list
                }
              }
              return {
                ...item,
                scheduleList: [...list]
              }
            })
          activeItem.value = data[0]
          hospitalList.value = data || []
        } else {
          hospitalList.value = []
          activeItem.value = {}
        }
      })
      .catch(error => {
        activeItem.value = {}
        hospitalList.value = []
      })
}
// 切换机构
const handleChange = value => {
  const item = hospitalList.value.find(item => item.hospitalId === value) || {}
  activeItem.value = item
}
onMounted(() => {
  getHospitalList()
  _getOutPatientInfoLog()
  REFRESH_SCHEDULE?.on(() => {
    getHospitalList()
    _getOutPatientInfoLog()
  })
})
onUnmounted(() => {
  REFRESH_SCHEDULE?.off()
})
const headerTxt = {
  1: '周一',
  2: '周二',
  3: '周三',
  4: '周四',
  5: '周五',
  6: '周六',
  7: '周天'
}

const iconSrc = require('@/assets/img/work-place/right.png')
const emit = defineEmits(['helpEditDoc'])
// 获取门诊排班操作记录-查询最新一条
const operationLog = ref({}) // 存储操作日志
const _getOutPatientInfoLog = () => {
  getDrOutpatientInfoLog({
    ucDoctorId: ucDoctorId.value
  }).then(res => {
    operationLog.value = res || {}
  })
}
watch(
  () => activeItem.value.hospitalId,
  () => {
    // sourceType 号源来源(0:施强健康,1:医院 HIS)
    const { hospitalId, sourceType } = activeItem.value || {}
    hospitalId && sourceType && getHospitalSetting(hospitalId)
  }
)
</script>
<style scoped lang="scss">
.doct_schedule {
  width: 304px;
  .fold {
    font-size: 14px;
    color: #1890ff;
    cursor: pointer;
  }
  .desc {
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    .descAct {
      display: flex;
      align-items: center;

      .helpIn {
        cursor: pointer;
        color: #333333;
      }
      .right {
        display: inline-block;
        width: 12px;
        height: 12px;
        margin-left: 8px;
      }
    }
  }
  .hospital_list {
    ::v-deep(.ant-select .ant-select-selector) {
      padding: initial;
    }
  }
  ul {
    display: flex;
    flex-direction: row;
    margin-bottom: 0;
    padding: 0;
    border: 2px solid #ffffff;
    box-shadow: -1px 0 9px 0 rgba(175, 175, 175, 0.06), 2px 4px 9px 0 rgba(175, 175, 175, 0.09);
    li {
      list-style: none;
      &.content {
        &.time {
          font-weight: 600;
          font-size: 12px;
          color: #3b3b3b;
        }
        div {
          width: 37.5px;
          height: 37.5px;
          text-align: center;
          line-height: 37.5px;
          background: #eff3f9;

          &.bottom_left {
            border-radius: 0 0 0 8px;
          }
          &.bottom_right {
            border-radius: 0 0 8px 0;
          }
        }
        .title {
          font-weight: 400;
          font-size: 12px;
          color: #666666;
          background: rgba(24, 144, 255, 0.2);
          &.top_left {
            border-radius: 8px 0 0 0;
          }
          &.top_right {
            border-radius: 0 8px 0 0;
          }
          .flex-col {
            display: flex;
            // flex-direction: column;
          }
        }
        .schedule {
          border-left: 1px solid #efefef;
          border-bottom: 1px solid #efefef;
          .have_schedule {
            color: #1890ff;
            font-size: 12px;
          }
        }
      }
    }
  }
  .schedule_table {
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .hospital_schedule {
    display: flex;
    width: 301px;
    border: 1px solid #e9eef2;
    border-radius: 8px;
    overflow: hidden;
    border-bottom: 0;
    margin-bottom: 12px;
    .content {
      .box {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 37.5px;
        height: 41.5px;
        font-size: 12px;
        color: #333333;
        border: 0.5px solid #e9eef2;
        border-left: 0;
        border-top: 0;
      }
      .title {
        background: rgba(24, 144, 255, 0.2);
        border: 0 !important;
        .date {
          font-weight: 500;
        }
        .week {
          font-size: 10px;
        }
      }
      .grey {
        color: #999999;
      }
    }
  }

  .updateTime {
    margin-top: 10px;
    color: #999999;
    font-size: 14px;
  }
  .flex-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
</style>
